// ABOUTME: Deposit payment dialog hook using global dialog store
// ABOUTME: Manages deposit payment dialog state with deposit data

import type { ApiSchemas } from "@/shared/api/schema";
import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "deposit-payment";

type DepositPaymentDialogData = {
  deposit: ApiSchemas["DepositRequest"];
};

export function useDepositPaymentDialog() {
  const {
    isOpen,
    open: openDialog,
    close,
    data,
  } = useGlobalDialogs<DepositPaymentDialogData>();

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: (deposit: ApiSchemas["DepositRequest"]) =>
      openDialog(DIALOG_ID, { deposit }),
    close,
    deposit: data?.deposit ?? null,
  };
}
